import React from 'react';

const AttachmentContent = ({attachments, isUpdate = false}) => {
    if (!attachments) return null;

    const attachmentList = Array.isArray(attachments) ? attachments : Object.values(attachments);
    if (attachmentList.length === 0) return null;

    const rows = attachmentList.filter(a => a?.old?.name || a?.new?.name).map((attach, index) => {

        const newAttach = attach?.new?.name ?? "";
        const oldAttach = attach?.old?.name ?? "";

        return (
            <tr key={index} className='text-left'>
                <td style={{width:"30%"}}>Nome</td>
                <td className={'break-all! whitespace-normal'} style={{width: isUpdate ? "35%" : "70%"}}> {newAttach} </td>

                {isUpdate && (
                    <td className={'break-all! whitespace-normal'} style={{width: "35%"}}> {oldAttach} </td>
                )}
            </tr>
        );
    });

    return (
        <tr className="bg-white attachment-content-table">
            <td colSpan={4}>
                <table className="w-full">
                    <thead>
                        <tr className='text-left'>
                            <th colSpan={4}>Anexos</th>
                        </tr>
                    </thead>

                    <tbody>
                        {rows}
                    </tbody>
                </table>
            </td>
        </tr>
    );
};

export default AttachmentContent;